import type { RouteObject } from 'react-router';
import { page } from '@/lib/lazy-route';

const reports = () => import('./reports-pages');
const dashboards = () => import('./dashboard-page');
const builder = () => import('./builder-page');
const saved = () => import('./saved-page');

// Home dashboard and reports (HaloPSA dashboards / BrightGauge). Owned by the reports module.
// Phase F: the home page is the user's dashboard (F2); /reports/builder and /reports/saved are F1.
export const routes: RouteObject[] = [
  { index: true, lazy: page(dashboards, (m) => m.DashboardHomePage) },
  { path: 'dashboards/:id', lazy: page(dashboards, (m) => m.DashboardPage) },
  { path: 'reports', lazy: page(reports, (m) => m.ReportsIndexPage) },
  { path: 'reports/builder', lazy: page(builder, (m) => m.ReportBuilderPage) },
  // Track 5 (PLT-M14): every scheduled report email.
  { path: 'reports/schedules', lazy: page(() => import('./schedules-page'), (m) => m.ScheduledReportsPage) },
  { path: 'reports/saved/:id', lazy: page(saved, (m) => m.SavedReportPage) },
  { path: 'reports/saved/:id/edit', lazy: page(builder, (m) => m.ReportBuilderPage) },
  { path: 'reports/:report', lazy: page(reports, (m) => m.ReportPage) },
];
export const orgRoutes: RouteObject[] = [];
